<template>
  <div>
        <div v-if="disable"  style="background: white;"><span style="color: red;">Bu öğe pasif olduğundan başvuru ekranında görüntülenmeyecektir. </span></div>

         <p class="ma-0" v-if="label">
          
            <strong style="color: black;"  v-html="label"> </strong> <strong v-if="required" style="color: red;margin:0px 5px;">*</strong> 
         </p> 
       
      

         <v-text-field v-model="value" :rules="getComponentName"  persistent-hint :hint="hint" v-mask="mask"
      :placeholder="placeholder" :prefix="prefix" :suffix="suffix">
      <!-- <template v-slot:label>
        <p>
          <strong v-if="required" style="color: red;margin:0px 5px;">*</strong> <strong v-html="label"> </strong>
        </p>
      </template> -->
      
   <template v-slot:append-outer>
    <slot name="edit"></slot>
   </template>
    </v-text-field> 
  </div>

<!-- <v-card :disabled="disable"  :class="{ pasifCard: disable }"
  elevation="3"
>
 <v-card-text >

    </v-card-text>

</v-card> -->
<!-- 
  <div>




  </div> -->

</template>
<script>
import { textSF } from '@/plugins/FieldDataFormat.js'
import { rules, CustomFunc } from '@/plugins/custom.js'
export default {
  data() {
    return {
      value: "",
      label: "",
      required: false,
      counter: 20,
      color: null,
      disable: false,
      hint: "",
      prefix: "",
      suffix: "",
      rules: [v => !!v || 'Name is required'],
      placeholder: "Yanıtınız",
      mask:""

    }
  },
  props: {
    ayar: {
      // default: '{"title":"","description":""}',
      default() {
        return textSF;
      },
      type: Object
    },


  },
  methods: {
    dataBind(json) {
     // console.log("Vtext Json", json);
      // let ayarJson = JSON.parse(jsonStr);
      this.value = json.value;
      this.title = json.title;
      this.description = json.description;
      this.rules = json.rules;
      this.hint = json.hint;
      this.label = json.label;
      this.placeholder = json.placeholder;
      this.prefix = json.prefix;
      this.suffix = json.suffix;
      this.required = json.required;
      this.disable=json.disable;
      this.mask=json.mask;
    }
  },
  computed: {
    getComponentName() {
      return this.rules.map(m => rules[m]);

    },
    // a computed getter
    getAyar: function () {
      // `this` points to the vm instance
      return this.ayar;
    },
    // iç kullanım için modelValue (opsiyonel)
    // model: {
    //   get() {
    //     return this.value;
    //   },
    //   set(val) {
    //     this.value=val;
    //     console.log("Model SEt",val);
    //    // this.$emit('input', val); // v-model'e değer gönder
    //   }
    // }
    //     model: {
    //   prop: 'value',
    //   event: 'input'
    // },

  },
  created() {
    this.dataBind(this.ayar);
  },
  watch: {
    ayar: {
      immediate: true,
      handler(newVal, oldVal) {
        this.dataBind(newVal);    
      },
      deep: true
    },
    value(n, o) {
      this.$emit('input', n);

    },
  },

}
</script>
<style scoped>
.pasifCard{
  background-color: gray !important;
}
</style>